import { graphql, useStaticQuery } from "gatsby"

export default function useAllPlacesData() {
  const data = useStaticQuery(graphql`
    query getAllPlacesData {
      allMarkdownRemark(
        filter: { frontmatter: { location: { is_region: { eq: true } } } }
        ) {
        edges {
          node {
            id
            frontmatter {
              title
              description
              location{
                region
                coordinates {
                  lat
                  long
                }
              }
              hero_image {
                childImageSharp {
                  fluid( maxWidth: 800 ) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)
  return data.allMarkdownRemark.edges
}